/** @jsx jsx */

import { keyframes } from '@emotion/react'
import React from 'react'
import { Text, jsx } from 'theme-ui'
import ImgLoader from '~/components/Generic/ImgLoader'
import { AddToCartProductList } from '~/components/Product/Card/AddToCartProductList'
import StickerTag from '~/components/Product/Grid/StickerTag'
import ProductLink from '~/components/Product/Link'
import StarRating from '~/components/Product/StarRating'
import BazaarStar from '~/components/Product/StarRating/BazaarStar'

const fadeIn = keyframes({
  from: { paddingLeft: '0', paddingRight: '0', paddingBottom: '0' },
  to: { paddingLeft: '8px', paddingRight: '8px', paddingBottom: '8px' },
})

export const CardSquare = ({ product, setOpenAtc, openAtc, collectionName }) => {
  const {
    mainImage,
    name,
    slug,
    isGoods,
    kitProductDisplayReference,
    stickAddToCartImage,
  } = product

  const sticker = product?.variants?.find(
    v => !!v.shopPageSticker,
  )?.shopPageSticker

  return (
    <div
      sx={{
        pt: '8px',
        mt: '2rem',
        backgroundColor: 'transparent',
        borderRadius: '12px',
        height: 'fit-content',
        position: 'relative',
      }}
    >
      <ProductLink
        slug={kitProductDisplayReference ? `/bundles/${slug}/` : slug}
        sx={{
          px: '8px',
          display: 'block',
        }}
      >
        {sticker?.title && (
          <StickerTag
            title={sticker.title}
            stroke={sticker.stroke}
            fill={sticker.fill}
            size={{
              width: [80, 80, 'min(120px,8vw)'],
              height: [82, 82, 'min(120px,8vw)'],
            }}
            position="custom"
            style={{
              top: ['-9px', '-9px', '18px'],
              left: ['-9px', '-9px', '18px'],
            }}
            textSize={['12px', '12px', '15px']}
          />
        )}
        <ImgLoader
          image={isGoods ? stickAddToCartImage : mainImage}
          slug={product.slug}
          forwardSx={{
            aspectRatio: '1',
            borderRadius: '8px',

            '&:hover': {
              img: {
                transformOrigin: 'center',
                transform: 'scale(1.1) translateY(-0%)',
              },
            },
          }}
        />

        <Text
          sx={{
            fontSize: ['16px', '18px'],
            lineHeight: ['16px', '18px'],
            maxHeight: isGoods ? ['16px', '18px'] : 'inital',
            color: 'primary',
            display: 'block',
            textAlign: 'center',
            mt: '16px',
            mb: isGoods ? ['22px', '8px'] : '8px',
            fontWeight: '700',
          }}
        >
          {name}
        </Text>

        {!isGoods && !kitProductDisplayReference && (
          <BazaarStar
            shopAll="shopAll"
            inline
            product={product}
            forwardSx={{
              width: '100%',
              justifyContent: 'center',
              mb: ['8px', '16px'],
            }}
          />
        )}
      </ProductLink>

      <div
        sx={{
          animation: openAtc !== name && `${fadeIn} 0.4s ease-in-out forwards`,
          animationDelay: '0.2s',
        }}
      >
        <AddToCartProductList
          product={kitProductDisplayReference || product}
          setOpenAtc={setOpenAtc}
          openAtc={openAtc}
          collectionName={collectionName}
        />
      </div>
    </div>
  )
}
